import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

export enum LanguageCode {
  en = 'en',
  ja = 'ja',
}
export const LANGUAGE_DEFAULT = LanguageCode.ja;

// Read saved language from localStorage (set by LanguageSwitcher), fallback to Japanese
const savedLng = localStorage.getItem('i18nextLng');
const initialLng = savedLng === LanguageCode.en || savedLng === LanguageCode.ja ? savedLng : LANGUAGE_DEFAULT;

i18n
  .use(LanguageDetector)
  .use(Backend)
  .use(initReactI18next)
  .init({
    lng: initialLng,
    fallbackLng: LANGUAGE_DEFAULT,
    ns: ['translation', 'messages', 'breadcrumb', 'elementProperties', 'primereact'],
    defaultNS: 'translation',
    detection: {
      order: ['querystring', 'localStorage', 'sessionStorage', 'htmlTag'],
      lookupQuerystring: 'lng',
      lookupLocalStorage: 'i18nextLng',
      lookupSessionStorage: 'i18nextLng',
      htmlTag: document.documentElement,
      // cache user language on
      caches: ['localStorage', 'cookie'],
      excludeCacheFor: ['cimode'], // languages to not persist (cookie, localStorage)
    },
    debug: false, // Disable debug mode after fixing translation issues
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
  });

i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng;
});
export default i18n;
